import gql from 'graphql-tag';

const UPDATE_KEY_CLASSROOM_ASSESSMENT_ACCELERATOR_MODULES_MUTATION = gql`
  mutation KeyClassroomAssessmentAcceleratorModules(
    $data: UpdateKeyClassroomSettingAssessmentAcceleratorInput!
  ) {
    updateKeyClassroomAssessmentAcceleratorModules(data: $data) {
      activityTypeId
      scheduledDates {
        date
        moduleIds
      }
    }
  }
`;

export default UPDATE_KEY_CLASSROOM_ASSESSMENT_ACCELERATOR_MODULES_MUTATION;
